import {useParams} from 'react-router-dom';

import {Header, Pagination, TableSkeleton} from '@/components';
import useUserDetails from '@/screens/User/Details/useUserDetails';

import RewardTransactionTable from './RewardTransactionTable';
import useRewardsTransactions from './useRewardsTransactions';

const RewardTransactions = () => {
  const {userId} = useParams();
  const {
    loading,
    transactions,
    pagination,
    isPageReset,
    getRewardTransactions,
  } = useRewardsTransactions(userId || '');
  const {isLoadingUserDetails, user: userDetails} = useUserDetails(
    userId || '',
  );
  const fullName = userDetails?.name?.fullName || null;

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header
        title={`Reward Transactions ${fullName ? 'for ' + fullName : ''}`}
      />

      <section className="pt-5 md:pt-5 justify-center">
        {loading || isLoadingUserDetails ? (
          <TableSkeleton />
        ) : (
          <RewardTransactionTable items={transactions} user={userDetails} />
        )}

        <Pagination
          total={pagination.total}
          limit={pagination.limit}
          isPageReset={isPageReset}
          onPageChange={({page, limit}) => getRewardTransactions({page, limit})}
        />
      </section>
    </main>
  );
};

export default RewardTransactions;
